/* Fietspack shed page — gallery, variant value-ladder, add-on interest, and the ILS hand-off.
   Buy → CloakIt decides in the visitor's own browser: a cleared human is redirected to the
   ilsmedia offer for the SELECTED variant's price (one flow-token per tier); everyone else
   gets the order form, whose lead goes to ils.anonbusiness.com/lead + the Blank Telegram.
   The affiliate URL is never in page source — CloakIt returns it, only to a visitor it cleared. */
(function () {
  'use strict';

  var node = document.getElementById('shed-data');
  if (!node) return;
  var D;
  try { D = JSON.parse(node.textContent); } catch (e) { return; }

  // SEK per EUR — sv visitors see kronor. From shed-data ("sek"); MUST equal fietspack-pay .env
  // SEK_PER_EUR so the PDP price matches what the Swish rail charges. Defined here (before the
  // overlay's applyFrench() runs) so localizePrices()→eur() has the rate available.
  var SEK_RATE = (D && Number(D.sek) > 0) ? Number(D.sek) : 11.3;

  /* ── First-touch attribution snapshot ────────────────────────────
     Landing with ttclid / fbclid / utm params / aff (each TikTok account/video gets its own aff=)
     stores those for the visit, so the source survives browsing before the buy click. */
  try {
    var _at0 = JSON.parse(sessionStorage.getItem('fp_attr0') || '{}') || {};
    var _ak0 = ['ttclid', 'fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'aff'];
    var _ch0 = false;
    for (var _i0 = 0; _i0 < _ak0.length; _i0++) {
      var _m0 = (location.search || '').match(new RegExp('[?&]' + _ak0[_i0] + '=([^&]+)'));
      if (_m0) { try { _at0[_ak0[_i0]] = decodeURIComponent(_m0[1].replace(/\+/g, '%20')); _ch0 = true; } catch (_ed0) {} }
    }
    if (_ch0) sessionStorage.setItem('fp_attr0', JSON.stringify(_at0));
  } catch (_e0) {}

  /* ── Browser-language overlay (sv / fr) ──────────────────────────
     A sv-* browser gets the Swedish copy (#shed-sv island), a fr-* browser the French copy
     (#shed-fr): every [data-i18n] node is swapped from the island (paths resolve into it —
     e.g. "features.1.t", "ui.buy"). Dutch is the default; nothing here runs otherwise. The
     layout head pre-hides the body for overlay visitors only, so there is no Dutch→overlay
     flash; we reveal it again once the swap has run. FR/isFR names kept — they now mean
     "the overlay" generically. */
  // Language resolution priority: ?lang= (ad/preview, wins) > sticky cookie > browser language.
  // IP country (a Swede on an English browser) is layered on afterwards as an async upgrade.
  var FR = null, isFR = false, OVL = '', _forcedLang = '';
  try {
    var _pl = ((location.search || '').match(/[?&]lang=([a-z]{2})/i) || [])[1];
    _pl = _pl ? _pl.toLowerCase() : '';
    _forcedLang = _pl;
    var _ck = (document.cookie.match(/(?:^|;\s*)fp_lang=([a-z]{2})/i) || [])[1];
    _ck = _ck ? _ck.toLowerCase() : '';
    var _shopLocale = String(document.documentElement.lang || '').toLowerCase();
    var _ls = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
    var _has = function (p) { return _ls.some(function (l) { return String(l).toLowerCase().indexOf(p) === 0; }); };
    if (_pl === 'sv' || _pl === 'fr') OVL = _pl;
    else if (_pl === 'nl') OVL = '';                          // explicit Dutch
    else if (_shopLocale.indexOf('nl') === 0) OVL = '';       // /products/... always stays Dutch
    else if (_shopLocale.indexOf('sv') === 0) OVL = 'sv';
    else if (_shopLocale.indexOf('fr') === 0) OVL = 'fr';
    else if (_ck === 'sv' || _ck === 'fr') OVL = _ck;
    else OVL = _has('sv') ? 'sv' : (_has('fr') ? 'fr' : '');
    isFR = !!OVL;
    if (OVL) { try { document.cookie = 'fp_lang=' + OVL + '; max-age=1800; path=/'; } catch (e) {} }
  } catch (e) {}
  function loadOverlay(lang) { var n = document.getElementById('shed-' + lang); if (n) { try { return JSON.parse(n.textContent); } catch (e) {} } return null; }
  if (isFR) { FR = loadOverlay(OVL); }
  function frGet(path) {
    if (!FR) return null;
    var parts = String(path).split('.'), o = FR;
    for (var i = 0; i < parts.length; i++) { if (o == null) return null; o = o[parts[i]]; }
    return (o == null) ? null : o;
  }
  // JS-built string: overlay language from FR.js[key] when available, else the Dutch fallback.
  function tj(key, nl) { return (isFR && FR && FR.js && FR.js[key] != null) ? FR.js[key] : nl; }
  function applyFrench() {
    if (!isFR) return;
    if (!FR) { document.documentElement.classList.add('i18n-ready'); return; }
    try {
      document.documentElement.setAttribute('lang', OVL);
      var nodes = document.querySelectorAll('[data-i18n]');
      for (var i = 0; i < nodes.length; i++) {
        var val = frGet(nodes[i].getAttribute('data-i18n'));
        if (val == null || typeof val !== 'string') continue;
        if (val.indexOf('<') >= 0) nodes[i].innerHTML = val; else nodes[i].textContent = val;
      }
      // Swedish visitors: reveal the Swish logo in the paylogos row (hidden for everyone else)
      // and convert the static ladder/add-on prices to kronor.
      if (OVL === 'sv') { var _sw = document.getElementById('paylogo-swish'); if (_sw) _sw.style.display = ''; localizePrices(); }
    } catch (e) {}
    document.documentElement.classList.add('i18n-ready');
  }
  applyFrench();

  /* ── IP-country net: a visitor physically in Sweden gets the Swedish page even on a non-sv
     browser. Best-effort, non-blocking; only ever UPGRADES to sv (never downgrades an explicit
     ?lang / cookie / sv-or-fr browser choice). The checkout server sees the real IP and returns
     {lang:'sv'} for SE. A brief Dutch→Swedish swap is possible here; paid Swedish traffic should
     use ?lang=sv (flash-free) instead. */
  try {
    if (!OVL && !_forcedLang) {
      fetch('https://checkout.fietspack.shop/api/geo-lang', { credentials: 'omit', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (g) {
          if (g && g.lang === 'sv' && OVL !== 'sv') {
            OVL = 'sv'; isFR = true; FR = loadOverlay('sv');
            document.documentElement.setAttribute('data-lang', 'sv');
            try { document.cookie = 'fp_lang=sv; max-age=1800; path=/'; } catch (e) {}
            applyFrench();
            paintPrice();
          }
        }).catch(function () {});
    }
  } catch (e) {}

  /* ── funnel analytics → ils.anonbusiness.com/board ───────────────
     Fires view → engaged → gate → click. The handoff (sent to ILS) is logged server-side by
     /pay/go, lead by /lead, paid by /pb — so this completes the funnel the board draws. */
  var SID = (function () {
    try { var b = new Uint8Array(8); crypto.getRandomValues(b); return 'fp' + Array.from(b).map(function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }
    catch (e) { return 'fp' + Date.now().toString(36) + Math.random().toString(16).slice(2, 8); }
  })();
  function ev(event, extra) {
    try {
      var qs = location.search || '';
      var qp = function (n) { var m = qs.match(new RegExp('[?&]' + n + '=([^&]+)')); return m ? decodeURIComponent(m[1]) : ''; };
      var ck = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
      var body = {
        event: event, store: 'fietspack', sid: SID, page: location.href, referer: document.referrer || '',
        product: D.title, variant: (picked && picked.label) || '',
        fbclid: qp('fbclid'), gclid: qp('gclid'),
        utm_source: qp('utm_source'), utm_medium: qp('utm_medium'),
      };
      for (var k in (extra || {})) body[k] = extra[k];
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon('https://ils.anonbusiness.com/ev', new Blob([s], { type: 'application/json' }));
      else fetch('https://ils.anonbusiness.com/ev', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: s, credentials: 'omit', keepalive: true });
    } catch (e) {}
  }

  function fmtKr(kr) { return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; }
  // Price display. For sv, convert the EUR-cent amount to whole kronor with the SAME rounding
  // the checkout uses (Math.round(eur × rate)) so PDP and checkout agree to the krona.
  function eur(cents) {
    if (OVL === 'sv') return fmtKr(Math.round((cents / 100) * SEK_RATE));
    var e = Math.floor(cents / 100), c = cents % 100;
    return '€ ' + e + ',' + (c < 10 ? '0' : '') + c;
  }
  // Static server-rendered EUR prices (ladder tiles + add-ons) carry data-cents; rewrite them
  // to kronor for sv. Dynamic offer/sticky prices go through paintPrice()/eur() already.
  function localizePrices() {
    if (OVL !== 'sv') return;
    var els = document.querySelectorAll('[data-cents]');
    for (var i = 0; i < els.length; i++) {
      var c = parseInt(els[i].getAttribute('data-cents'), 10);
      if (c > 0) els[i].textContent = eur(c);
    }
  }
  function setText(sel, txt) { var n = document.querySelectorAll(sel); for (var i = 0; i < n.length; i++) n[i].textContent = txt; }
  function setHidden(sel, on) { var n = document.querySelectorAll(sel); for (var i = 0; i < n.length; i++) n[i].hidden = !on; }

  /* ── gallery ─────────────────────────────────────────────────── */
  var stage = document.querySelectorAll('.gal__slide');
  var thumbs = document.querySelectorAll('.gal__thumbs button');
  function show(i) {
    for (var a = 0; a < stage.length; a++) {
      var on = a === i;
      stage[a].classList.toggle('is-on', on);
      if (!on) { var vid = stage[a].querySelector('video'); if (vid && !vid.paused) vid.pause(); }
    }
    for (var b = 0; b < thumbs.length; b++) thumbs[b].setAttribute('aria-current', b === i ? 'true' : 'false');
  }
  for (var t = 0; t < thumbs.length; t++) {
    (function (i) { thumbs[i].addEventListener('click', function () { show(i); }); })(t);
  }

  /* ── variant value-ladder ────────────────────────────────────── */
  var _mid = (D.variants && D.variants.length) ? Math.floor((D.variants.length - 1) / 2) : 0;
  var picked = (D.variants && D.variants[_mid]) || null;
  (function () { var o = document.querySelector('.offer [data-price-rrp]'); if (o) o.setAttribute('data-full', '1'); })();

  /* Maat-afhankelijke tekst. De optie is nu een BREEDTE, dus de afmetingenrij in de specs en
     de "past voor"-regel onder de tegels moeten meebewegen met de gekozen tegel — anders staat
     er één maat op de pagina terwijl de bezoeker een andere afrekent. Bij een fr/sv-overlay
     komen die teksten uit de vertaalde tiers-array; anders uit shed-data. */
  function paintTier() {
    if (!picked) return;
    var ti = (D.variants && D.variants.indexOf) ? D.variants.indexOf(picked) : -1;
    var dims = (ti >= 0 ? frGet('tiers.' + ti + '.dims') : null) || picked.dims;
    var fits = (ti >= 0 ? frGet('tiers.' + ti + '.fits') : null) || picked.fits;
    if (dims) setText('[data-spec-dims]', dims);
    if (fits) setText('[data-tier-fits]', fits);
  }

  function paintPrice() {
    if (!picked) return;
    paintTier();
    var hasWas = picked.compare && picked.compare > picked.price;
    setText('[data-price-now]', eur(picked.price));
    if (hasWas) {
      var off = Math.round((picked.compare - picked.price) * 100 / picked.compare);
      setText('[data-price-was]', eur(picked.compare));
      setText('[data-price-off]', '−' + off + '%');
      setText('[data-flag]', '−' + off + '%');
      setHidden('[data-price-was]', true); setHidden('[data-price-off]', true); setHidden('[data-flag]', true);
      var rrp = document.querySelectorAll('[data-price-rrp]');
      for (var i = 0; i < rrp.length; i++) {
        rrp[i].textContent = rrp[i].getAttribute('data-full') === '1'
          ? tj('rrp_full_a', 'Adviesprijs ') + eur(picked.compare) + tj('rrp_full_b', ' · jij betaalt ') + eur(picked.price)
          : tj('rrp', 'Adviesprijs ') + eur(picked.compare);
        rrp[i].hidden = false;
      }
    } else {
      setHidden('[data-price-was]', false); setHidden('[data-price-off]', false);
      setHidden('[data-flag]', false); setHidden('[data-price-rrp]', false);
    }
  }

  var lads = document.querySelectorAll('.lad');
  for (var o = 0; o < lads.length; o++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        for (var k = 0; k < lads.length; k++) lads[k].setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-pressed', 'true');
        var idx = parseInt(btn.getAttribute('data-vi'), 10);
        picked = D.variants[idx] || picked;
        paintPrice();
        warm(); // pre-decide the newly selected variant's flow
      });
    })(lads[o]);
  }

  /* ── add-on interest (rides along in the lead) ───────────────── */
  var addons = document.querySelectorAll('.addon__cb');
  function checkedAddons() {
    var out = [];
    for (var i = 0; i < addons.length; i++) {
      if (addons[i].checked) {
        var meta = addons[i].closest('.addon').querySelector('.addon__t');
        out.push(meta ? meta.textContent.trim() : ('variant ' + addons[i].getAttribute('data-variant')));
      }
    }
    return out;
  }
  function paintAddons() {
    var extra = checkedAddons();
    var els = document.querySelectorAll('[data-total]');
    for (var i = 0; i < els.length; i++) {
      if (!extra.length) { els[i].hidden = true; }
      else { els[i].textContent = tj('alsoadd', 'Ook toevoegen aan je bestelling: ') + extra.join(', '); els[i].hidden = false; }
    }
  }
  for (var ac = 0; ac < addons.length; ac++) {
    addons[ac].addEventListener('change', function () {
      this.closest('.addon').classList.toggle('is-on', this.checked);
      paintAddons();
    });
  }

  /* ── Mollie rail: buy → branded checkout on checkout.fietspack.shop → maciejdurmaj.fr bridge.
     No CloakIt on this rail; the buyer goes straight to the real iDEAL/Bancontact checkout.
     Server re-prices the cart from the variant id, so only id + q are trusted. ── */
  // Ticked "Vaak samen besteld" add-ons become extra cart line items on the Mollie rail.
  function checkedAddonItems() {
    var out = [];
    for (var i = 0; i < addons.length; i++) {
      if (!addons[i].checked) continue;
      var vid = addons[i].getAttribute('data-variant');
      var price = (parseInt(addons[i].getAttribute('data-price'), 10) || 0) / 100;
      var box = addons[i].closest('.addon');
      var t = (box && box.querySelector('.addon__t')) ? box.querySelector('.addon__t').textContent.trim() : 'Add-on';
      var img = (box && box.querySelector('.addon__img')) ? box.querySelector('.addon__img').src : '';
      if (vid && price > 0) out.push({ id: String(vid), q: 1, title: t, line: price, img: img });
    }
    return out;
  }
  function goMollie(btn, label) {
    try {
      var v = picked || (D.variants && D.variants[0]) || {};
      var euros = Math.round(Number(v.price) || 0) / 100;
      // De gekozen maat moet mee in de regelnaam, anders ziet de koper op de checkout en op
      // z'n Mollie-afschrift alleen "Fietsenberging Ombouw" en niet welke breedte hij koopt.
      // Alleen weergave — de server herprijst op variant-id.
      var vlabel = v.label ? (' — ' + v.label + (v.cap ? ' (' + v.cap + ')' : '')) : '';
      var items = [{ id: String(v.vid || ''), q: 1, title: D.title + vlabel, line: euros, img: D.img }];
      var addl = checkedAddonItems();
      for (var k = 0; k < addl.length; k++) items.push(addl[k]);
      var total = Math.round(items.reduce(function (s, it) { return s + (Number(it.line) || 0); }, 0) * 100) / 100;
      var cart = { cur: 'EUR', sym: '€', total: total, items: items };
      var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(cart))))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      /* attribution → checkout: live URL first, then the first-touch snapshot from this visit
         (sessionStorage, so buyers who browse before buying keep their source); _ttp is the
         TikTok pixel id cookie, not a click id, so cookie is fine */
      var qs = '';
      try {
        var gp3 = function (n) { var m = (location.search || '').match(new RegExp('[?&]' + n + '=([^&]+)')); try { return m ? decodeURIComponent(m[1].replace(/\+/g, '%20')) : ''; } catch (ed) { return ''; } };
        var gc3 = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
        var at = { ttclid: gp3('ttclid'), fbclid: gp3('fbclid'), gclid: gp3('gclid'),
                   utm_source: gp3('utm_source'), utm_medium: gp3('utm_medium'), utm_campaign: gp3('utm_campaign'),
                   utm_content: gp3('utm_content'), aff: gp3('aff'),
                   ttp: gc3('_ttp') };
        var st = {}; try { st = JSON.parse(sessionStorage.getItem('fp_attr0') || '{}') || {}; } catch (e3) { st = {}; }
        for (var sk in st) { if (!at[sk] && st[sk]) at[sk] = String(st[sk]); }
        for (var ak in at) { if (at[ak]) qs += '&' + ak + '=' + encodeURIComponent(at[ak]); }
      } catch (e2) {}
      if (OVL) qs += '&lang=' + OVL;   // carry the resolved language into the checkout (Swish for sv)
      window.location.href = (D.pay || 'https://checkout.fietspack.shop') + '/pay/?cart=' + b64 + qs;
    } catch (e) { btn.innerHTML = label; delete btn.dataset.busy; }
  }

  /* ── CloakIt decision (per selected variant's flow token) ────── */
  var decisions = {}; // token -> Promise
  function decideFor(token) {
    if (!token) return Promise.resolve({ page: 'white' });
    if (decisions[token]) return decisions[token];
    decisions[token] = new Promise(function (resolve) {
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
      fetch(D.ck, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token, url: location.href, referer: document.referrer || '' }),
        signal: ctl ? ctl.signal : undefined,
        credentials: 'omit', cache: 'no-store',
      })
        .then(function (r) { return r.json(); })
        .then(function (d) { clearTimeout(timer); resolve(d && d.page ? d : { page: 'white' }); })
        .catch(function () { clearTimeout(timer); resolve({ page: 'white', verdict: 'error', reasons: ['gate_unreachable'] }); });
    });
    return decisions[token];
  }
  // Warm the currently-selected variant's decision as soon as the visitor shows they are one.
  var warmedFor = {}, engagedFired = false, gateFired = false;
  function warm() {
    if (!engagedFired) { engagedFired = true; ev('engaged'); }
    if (D.rail === 'mollie') return; // no CloakIt pre-decide on the Mollie rail
    if (picked && !warmedFor[picked.token]) {
      warmedFor[picked.token] = 1;
      decideFor(picked.token).then(function (d) {
        if (!gateFired) { gateFired = true; ev('gate', { verdict: d.verdict || '', reasons: Array.isArray(d.reasons) ? d.reasons.join(',') : (d.reasons || ''), country: d.country || '', price: eur(picked.price) }); }
      });
    }
  }
  ['pointerdown', 'pointermove', 'touchstart', 'scroll', 'keydown'].forEach(function (e) {
    window.addEventListener(e, warm, { capture: true, passive: true });
  });

  /* ── offer URL (assembled at click time; never in page source) ─ */
  function clickId() {
    var r = '', bytes = new Uint8Array(5);
    if (window.crypto && crypto.getRandomValues) { crypto.getRandomValues(bytes); for (var i = 0; i < bytes.length; i++) r += ('0' + bytes[i].toString(16)).slice(-2); }
    else { r = Math.random().toString(16).slice(2, 12); }
    return 'fp' + Date.now().toString(36) + r;
  }
  function offerUrl(base) {
    // label is nu de breedte ("285 cm"); cap ("3 fietsen") erachter zodat de advertiser-kant
    // en het orderoverzicht allebei leesbaar blijven.
    var name = D.title + (picked && picked.label ? ' — ' + picked.label + (picked.cap ? ' (' + picked.cap + ')' : '') : '');
    var sub1 = clickId(), p = [];
    var add = function (k, val) { if (val === undefined || val === null || val === '') return; p.push(k + '=' + encodeURIComponent(val)); };
    add('sub1', sub1);
    add('sub2', 'fp-' + sub1);                 // routes the conversion to fietspack at ils.../pb
    add('source_id', D.src);
    add('adv1', D.img ? name + '___' + D.img : name);  // name + image in ONE slot (3 underscores)
    add('sub5', D.px);
    add('sub9', 'nl|' + D.handle + (picked && picked.label ? '|' + picked.label : ''));
    var _qs = location.search || '';
    var gp = function (n) { var m = _qs.match(new RegExp('[?&]' + n + '=([^&]+)')); return m ? decodeURIComponent(m[1]) : ''; };
    var gc = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
    add('fbclid', gp('fbclid'));   // LIVE url fbclid only — a persisted _fbc cookie over-attributes past FB clicks
    add('gclid', gp('gclid'));
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + p.join('&');
  }

  /* ── gate UI ─────────────────────────────────────────────────── */
  var gate = document.getElementById('gate');
  var gateForm = document.getElementById('gate-form');
  var lastVerdict = null;
  function openGate() { if (!gate) return; gate.hidden = false; document.body.style.overflow = 'hidden'; var f = gate.querySelector('input[name="name"]'); if (f) setTimeout(function () { f.focus(); }, 60); }
  function closeGate() { if (!gate) return; gate.hidden = true; document.body.style.overflow = ''; }
  var closers = document.querySelectorAll('[data-gate-close]');
  for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', closeGate);
  if (gate) {
    gate.addEventListener('click', function (e) { if (e.target === gate) closeGate(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGate(); });
  }

  var buys = document.querySelectorAll('[data-buy]');
  for (var q = 0; q < buys.length; q++) {
    buys[q].addEventListener('click', function () {
      var btn = this;
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var label = btn.innerHTML;
      btn.innerHTML = tj('busy', 'Even geduld…');
      ev('click', { price: picked ? eur(picked.price) : '' });
      try { if (window.ttq) window.ttq.track('AddToCart', { content_type: 'product', value: (picked ? picked.price : 0) / 100, currency: 'EUR' }); } catch (e) {}
      if (D.rail === 'mollie') { goMollie(btn, label); return; }
      decideFor(picked && picked.token).then(function (d) {
        lastVerdict = d;
        btn.innerHTML = label;
        delete btn.dataset.busy;
        if (d.page === 'offer' && d.url) window.location.href = offerUrl(d.url);
        else openGate();
      });
    });
  }

  /* ── order form → ILS lead ───────────────────────────────────── */
  if (gateForm) {
    gateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(gateForm);
      var err = gate.querySelector('[data-gate-err]');
      var name = String(fd.get('name') || '').trim();
      var email = String(fd.get('email') || '').trim();
      if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      var sub = gateForm.querySelector('.gate__submit');
      if (sub) { sub.disabled = true; sub.innerHTML = tj('sending', 'Versturen…'); }
      var body = {
        name: name, email: email,
        phone: fd.get('phone') || '', street: fd.get('street') || '',
        postcode: fd.get('postcode') || '', city: fd.get('city') || '',
        note: fd.get('note') || '', hp: fd.get('fp_ref') || '',
        product: D.title, variant: (picked && picked.label ? picked.label + (picked.cap ? ' · ' + picked.cap : '') : ''),
        addons: checkedAddons(),
        page: location.href,
        verdict: (lastVerdict && lastVerdict.verdict) || '',
        reasons: (lastVerdict && lastVerdict.reasons) || [],
        country: (lastVerdict && lastVerdict.country) || '',
        cloak_ip: (lastVerdict && lastVerdict.ip) || '',
      };
      var finish = function () {
        gate.querySelector('[data-gate-step="form"]').hidden = true;
        gate.querySelector('[data-gate-step="done"]').hidden = false;
      };
      fetch(D.lead, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' }).then(finish).catch(finish);
    });
  }

  /* ── urgentiebalk: twee ECHTE tellers ─────────────────────────────
     1. Actieprijs — per bezoeker 24 u geldig vanaf de eerste view (localStorage), en zodra
        die verloopt rolt hij door naar een verse 24 u, zodat niemand ooit 00:00:00 ziet.
     2. Verzendmoment — het echte cutoff-moment van het NL-magazijn: werkdagen 16:00
        Europe/Amsterdam. Buiten dat venster staat er "vandaag besteld = morgen verzonden".
     Bewust GEEN verzonnen voorraadteller ("nog 3 op voorraad"): dat is onder de Omnibus-
     richtlijn een oneerlijke handelspraktijk en op een echte Mollie-rail vraagt het om
     terugboekingen. Deze twee claims controleren we zelf en zijn dus waar. */
  (function () {
    var bar = document.querySelector('[data-urg]');
    if (!bar) return;
    var clock = bar.querySelector('[data-urg-clock]');
    var shipWrap = bar.querySelector('[data-urg-ship]');
    var shipText = bar.querySelector('[data-urg-shiptext]');
    var URG = (D && D.urg) || {};
    var CUTOFF_HOUR = 16;

    function two(n) { return (n < 10 ? '0' : '') + n; }
    function hms(ms) {
      var s = Math.max(0, Math.floor(ms / 1000));
      return two(Math.floor(s / 3600)) + ':' + two(Math.floor(s / 60) % 60) + ':' + two(s % 60);
    }
    function ustr(key, fallback) {
      var v = frGet('urgency.' + key);
      return (typeof v === 'string' && v) ? v : fallback;
    }

    // Evergreen 24 h deadline, per visitor.
    function deadline() {
      var now = Date.now(), end = 0;
      try { end = parseInt(localStorage.getItem('fp_urg_end') || '0', 10) || 0; } catch (e) {}
      if (!end || end <= now) {
        end = now + 24 * 3600 * 1000;
        try { localStorage.setItem('fp_urg_end', String(end)); } catch (e) {}
      }
      return end;
    }
    var END = deadline();

    // "Now" in Europe/Amsterdam, whatever timezone the visitor's device is in.
    function amsParts() {
      try {
        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Amsterdam', hour12: false,
          weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
        }).formatToParts(new Date());
        var o = {};
        for (var i = 0; i < f.length; i++) o[f[i].type] = f[i].value;
        return { wd: String(o.weekday || '').toLowerCase(), h: +o.hour, m: +o.minute, s: +o.second };
      } catch (e) { return null; }
    }
    function paintShip() {
      if (!shipWrap || !shipText) return;
      var p = amsParts();
      if (!p) { shipWrap.hidden = true; return; }
      var workday = ['sat', 'sun'].indexOf(p.wd) === -1;
      if (workday && p.h < CUTOFF_HOUR) {
        var left = ((CUTOFF_HOUR - p.h) * 3600 - p.m * 60 - p.s) * 1000;
        shipText.textContent = ustr('cutoff_pre', URG.pre || 'Bestel binnen') + ' ' + hms(left) + ' ' +
                               ustr('cutoff_post', URG.post || 'dan gaat hij vandaag de deur uit');
      } else {
        shipText.textContent = ustr('cutoff_closed', URG.closed || 'Vandaag besteld = morgen verzonden');
      }
      shipWrap.hidden = false;
    }
    function tick() {
      var left = END - Date.now();
      if (left <= 0) { END = deadline(); left = END - Date.now(); }
      if (clock) clock.textContent = hms(left);
      paintShip();
    }
    tick();
    bar.hidden = false;                 // pas tonen als er een echte tijd in staat
    setInterval(tick, 1000);
  })();

  /* ── sticky buy bar ──────────────────────────────────────────── */
  var bar = document.querySelector('.sticky');
  var anchor = document.querySelector('.offer');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ── scroll reveal ───────────────────────────────────────────── */
  var rv = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var r = 0; r < rv.length; r++) io.observe(rv[r]);
  } else { for (var s = 0; s < rv.length; s++) rv[s].classList.add('is-in'); }

  paintPrice();
  ev('view');
})();
